import React from 'react';

export const HamLogo = () => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.25 17H21.25M4.25 8.5H29.75M4.25 25.5H29.75"
        stroke="#414651"
        stroke-width="2.83333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
